import * as React from 'react';
import { Form, Input } from 'antd';
import { LINK_TITLE, LINK_URL, MESSAGES_COPY, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';

const { MAX: titleMax, MESSAGE: titleMessage } = LINK_TITLE;
const { MAX: urlMax, MESSAGE: urlMessage } = LINK_URL;

interface LinkInputProps {
	disabled?: boolean;
}

export const LinkInput: React.FC<LinkInputProps> = ({ disabled }) =>
	<>
		<Form.Item
			name='title'
			rules={ [
				{
					max: titleMax,
					message: titleMessage
				}
			] }>
			<Input
				autoFocus
				disabled={ disabled }
				placeholder={ PLACEHOLDERS_COPY.LINK_TITLE }
				type='text' />
		</Form.Item>

		<Form.Item
			name='url'
			rules={ [
				{
					message: urlMessage,
					required: true
				},
				{
					max: urlMax,
					message: MESSAGES_COPY.MAX_LENGTH_EXCEEDED
				}
			] }>
			<Input
				disabled={ disabled }
				placeholder={ PLACEHOLDERS_COPY.LINK_URL } />
		</Form.Item>
	</>;

